export default __webpack_public_path__ + "static/media/jangwon_banner.7d2b04f7.jpeg";